import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import ReduxThunk from 'redux-thunk'
import { Amplify, Auth } from 'aws-amplify';
import * as _ from 'lodash';

import { LOGIN_SUCCESS } from '../actions/types'
import rootReducer from '../reducers'
import { fetchMyProfile } from '../actions'

const config = {
  API: {
    endpoints: [
      {
        name: "TasksAPI",
        endpoint: process.env.REACT_APP_TASKS_API
      },
      {
        name: "LogsAPI",
        endpoint: process.env.REACT_APP_LOGS_API
      },
      {
        name: "UsersAPI",
        endpoint: process.env.REACT_APP_USERS_API
      },
    ]
  },
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_BUCKET,
      region: process.env.REACT_APP_REGION
    }
  }
}

const initializeUser = async (store) => {
  try {
    let cs = await Auth.currentSession()
    console.log('currentSession: ', cs)

    let isAdmin = _.includes(_.get(cs, 'accessToken.payload.cognito:groups', []), 'Admin')
    console.log('isAdmin', isAdmin)
    store.dispatch({ type: LOGIN_SUCCESS, payload: { isAdmin } })
    // TODO: fetchMyDetails
    store.dispatch(fetchMyProfile())
  } catch (err) {
    console.log('NO USER LOGGED IN', err)
  }
}

export const InitializeApp = () => {
  /* ------------- AWS Amplify Configuration ------------- */
  Amplify.configure(config);

  /* ------------- Redux Configuration ------------- */
  const middleware = []
  const enhancers = []

  /* ------------- ReduxThunk Middleware ------------- */
  middleware.push(ReduxThunk)

  /* ------------- Redux Logger Middleware ------------- */
  // Note: logger must be the last middleware in chain, otherwise it will log
  // thunk and promise, not actual actions.

  function noop() { }

  if (process.env.NODE_ENV === 'development') {
    const { createLogger } = require('redux-logger')
    const logger = createLogger({ collapsed: true, duration: true, diff: true })
    middleware.push(logger)
  } else {
    console.log = noop;
    console.warn = noop;
    console.error = noop;
  }

  /* ------------- Assemble Middleware ------------- */
  const middlewareEnhancer = applyMiddleware(...middleware)
  enhancers.push(middlewareEnhancer)

  const persistConfig = {
    key: 'REDUX_OFFLINE_STORE',
    storage,
    whitelist: ['general', 'user', 'tasks', 'notifications']
  }

  const persistedReducer = persistReducer(persistConfig, rootReducer)
  const store = createStore(persistedReducer, {}, compose(...enhancers))
  const persistor = persistStore(store)

  initializeUser(store)

  return { store, persistor }
}
